export const isThereAnyPriceEmpty = (data) => {
  let hasEmpty = false;
  const productTable = data.entities[1].data;
  productTable.forEach(v => {
    if (v.na_89 === null || v.na_89 === "" || v.na_89 === undefined || v.na_89 === "0" || v.na_89 === 0) {
      hasEmpty = true;
    }
  })
  return hasEmpty
}
export const isThereAnyNumberEmpty = (data) => {

  let hasEmpty = false;
  const productTable = data.entities[1].data;
  productTable.forEach(v => {
    if (v.na_319 === null || v.na_319 === "" || v.na_319 === undefined || v.na_319 === "0" || v.na_319 === 0) {
      hasEmpty = true;
    }
  })
  return hasEmpty
}